import { forwardRef } from 'react';

import { VFlex } from '../VFlex';
import { STATUS_BADGE_SIZE, STATUS_BADGE_VARIANT } from './constant';
import twStyle from './style';
import type { VStatusBadgeProps } from './type';

const VStatusBadge = (
  {
    children,
    size = STATUS_BADGE_SIZE.MD,
    variant = STATUS_BADGE_VARIANT.COMPLETED,
  }: React.PropsWithChildren<VStatusBadgeProps>,
  ref?: React.Ref<HTMLDivElement>,
) => {
  const classNameMap = twStyle.vStatusBadge({ size, variant: variant });

  return (
    <VFlex
      ref={ref}
      justify="center"
      items="center"
      className={classNameMap.container()}
    >
      <div className={classNameMap.text()}>{children}</div>
    </VFlex>
  );
};

export default forwardRef(VStatusBadge);
